"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankCodeType = exports.TransferRefundType = exports.BankAccountFormatType = void 0;
var BankAccountFormatType;
(function (BankAccountFormatType) {
    BankAccountFormatType["CZECH"] = "CZECH";
    BankAccountFormatType["IBAN"] = "IBAN";
    BankAccountFormatType["OTHER"] = "OTHER";
})(BankAccountFormatType || (BankAccountFormatType = {}));
exports.BankAccountFormatType = BankAccountFormatType;
var TransferRefundType;
(function (TransferRefundType) {
    TransferRefundType["DOMESTIC"] = "DOMESTIC";
    TransferRefundType["FOREIGN"] = "FOREIGN";
    TransferRefundType["SEPA"] = "SEPA";
})(TransferRefundType || (TransferRefundType = {}));
exports.TransferRefundType = TransferRefundType;
var BankCodeType;
(function (BankCodeType) {
    BankCodeType["Bic"] = "BIC";
    BankCodeType["Bik"] = "BIK";
    BankCodeType["Au"] = "AU";
    BankCodeType["Cc"] = "CC";
    BankCodeType["Fw"] = "FW";
})(BankCodeType || (BankCodeType = {}));
exports.BankCodeType = BankCodeType;
